export function hotKeyAccumulatorFactory() {
  let keys = [];
  let timerId = null;

  const keyAccumulator = (key) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => (keys = []), 500);

    return (keys = [...keys, key]);
  };

  return keyAccumulator;
}
